/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type FinancialListFinancialRequest = {
  perPage?: number | null;
  page?: number | null;
  keyword?: string | null;
  sort?: string | null;
  direction?: FinancialListFinancialRequest.direction | null;
};

export namespace FinancialListFinancialRequest {
  export enum direction {
    ASC = "asc",
    DESC = "desc",
  }
}
